import React, { useEffect } from 'react';
import { downloadFile } from '$/store/export/actions';
import { CloService } from '$/services';
import * as FileSaver from 'file-saver';
import * as Bixby from '$/core';
import { NavigateFunction, useNavigate } from 'react-router-dom';

const downloadSfdrWhitePaper = async (navigate: NavigateFunction | undefined) => {
  const { blob, filename } = await CloService.downloadSfdrWhitePaper();
  downloadFile(blob, filename ?? Bixby.Constants.DOCUMENT_HOSTING_SFDR_WHITEPAPER);
  FileSaver.saveAs(blob, filename);

  if (navigate) {
    navigate('/');
  }
};

const SfdrWhitePaperDownload: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    downloadSfdrWhitePaper(navigate);
  }, [navigate]);

  return null;
};

export default SfdrWhitePaperDownload;
